'use client'

import { useState } from 'react'
import { Search } from 'lucide-react'
import Link from 'next/link'

const agencies = [
  {
    name: 'Department of Defense',
    acronym: 'DOD',
    description: 'Federal department charged with coordinating and supervising all agencies and functions of the government concerned directly with national security and the United States Armed Forces.',
    activeContracts: 2456,
    totalValue: '$892B',
    website: 'https://www.defense.gov',
  },
  {
    name: 'Department of Energy',
    acronym: 'DOE',
    description: 'Federal department concerned with U.S. policies regarding energy and safety in handling nuclear material.',
    activeContracts: 1243,
    totalValue: '$245B',
    website: 'https://www.energy.gov',
  },
  {
    name: 'National Aeronautics and Space Administration',
    acronym: 'NASA',
    description: 'Independent agency of the U.S. federal government responsible for the civilian space program, aeronautics research, and space research.',
    activeContracts: 856,
    totalValue: '$124B',
    website: 'https://www.nasa.gov',
  },
  {
    name: 'Department of Homeland Security',
    acronym: 'DHS',
    description: 'Federal department responsible for public security, roughly comparable to the interior or home ministries of other countries.',
    activeContracts: 1567,
    totalValue: '$298B',
    website: 'https://www.dhs.gov',
  },
]

export default function AgenciesPage() {
  const [searchTerm, setSearchTerm] = useState('')

  const filteredAgencies = agencies.filter(
    (agency) =>
      agency.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      agency.acronym.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <div className="container max-w-7xl mx-auto px-4 py-16">
      <div className="mb-12">
        <h1 className="text-4xl font-bold mb-4">Federal Agencies</h1>
        <p className="text-xl text-muted-foreground mb-8">
          Explore federal agencies and their contract opportunities
        </p>

        <div className="relative max-w-2xl">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search agencies by name or acronym..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 rounded-md border border-input bg-background"
          />
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        {filteredAgencies.map((agency) => (
          <div
            key={agency.acronym}
            className="border rounded-lg p-6 bg-card hover:shadow-lg transition-shadow"
          >
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="text-xl font-semibold mb-1">{agency.name}</h3>
                <p className="text-primary font-medium">{agency.acronym}</p>
              </div>
            </div>
            <p className="text-muted-foreground mb-4 line-clamp-2">
              {agency.description}
            </p>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <p className="text-sm text-muted-foreground">Active Contracts</p>
                <p className="font-medium">{agency.activeContracts.toLocaleString()}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Total Value</p>
                <p className="font-medium">{agency.totalValue}</p>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <Link
                href={agency.website}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-primary hover:underline"
              >
                Visit Website
              </Link>
              <Link
                href={`/federal/agencies/${agency.acronym.toLowerCase()}`}
                className="text-sm text-primary hover:underline"
              >
                View Contracts →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}